import { StyledCss } from '@microfrontends/react-components'
import styled, { css } from 'styled-components'

export const DropdownBodyStyledWrapper = styled.div<{ maxHeight: number; isHaveScrollBar: boolean; residualHeight: number }>`
    margin: 24px 0;
    height: calc(100vh - 230px - ${({ residualHeight }) => residualHeight}px);
    ${({ isHaveScrollBar }) => {
        if (!isHaveScrollBar) {
            return ''
        }
        return css`
            padding-right: 8px;
        `
    }}
    ${({ maxHeight }) => {
        if (maxHeight === -1) {
            return ''
        }
        return css`
            max-height: ${maxHeight}px;
        `
    }}
    overflow-y: auto;
    .dropdown-row {
        margin-bottom: 16px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    ${StyledCss.scrollbar};

    .tree-select {
        [data-id="tree-select"] {
            > div > div > div {
                color: #333;
                font-size: 14px;
            }
            .btn-default.btn-md.clickable {
                display: none;
            }
        }
    }
`
